import { fetchFromOldApi } from '~/services/Http';

export const postHomePageSettings = (postData: FormData) =>
  fetchFromOldApi(`/form/custom/appearance`, {
    method: 'PUT',
    body: postData,
  }).then((resp) => resp.json());

export const deleteHomePageBG = (pictureId: string) =>
  fetchFromOldApi(`/json/custom/appearance/delete/picture/${pictureId}`, {
    method: 'DELETE',
  });
